import BroadcastLock from './BroadcastLock';

export default BroadcastLock;